import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, useMediaQuery, Dialog, DialogActions, DialogContent } from "@mui/material";
import { Button, Card, CardContent, Divider, Grid, } from "@material-ui/core";
import { useTheme } from "@mui/system";
import { Images } from "lucide-react";
function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function ReservationTabs({ spaceData, bookSpace, facilities, additionalDetails, addressLine1, addressLine2, addressLine3, rules, changes, mapURL }) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const SiteSpacecard = ({ space, bookSpace, setOpen, setImages }) => {

        const [expanded, setExpanded] = useState(false);
        const handleToggleDetails = () => {
            setExpanded((prev) => !prev);
        };

        // const RECAPTCHA_SITE_KEY = "6LeeMM8qAAAAADdGtux8uA_B45ewNBXrTuoiZRPJ";
        // const handleBookSpace = async () => {
        //     try {
        //         if (!window.grecaptcha) {
        //             console.error("reCAPTCHA not loaded");
        //             return;
        //         }
        //         const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: "submit" });
        // bookSpace(space);
        //     } catch (error) {
        //         console.error("reCAPTCHA error:", error);
        //     }
        // };

        return (<Card>
            <Grid container>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    style={{ textAlign: "left", minHeight: "200px" }}
                >
                    <CardContent style={{display:'flex', alignItems:"center", gap:"30px"}}>
                       { space?.image_url ? <div style={{width:'27%'}}>
                            <img style={{width:"100%", height:"100%"}} src={space?.image_url} alt="Image Coming soon"/>
                        </div>:null}
                        <div style={{width:'100%'}}>
                            <h3 style={{ opacity: 0.7 }}> Space name: {space.space_name}</h3>
                            <p>
                                {space.description}
                            </p>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <p>
                                    <span style={{ fontWeight: "bold" }}> Daily:</span>{" "}
                                    <span>${parseFloat(space.daily_rate).toFixed(2)}</span>
                                </p>
                                <p>
                                    <span style={{ fontWeight: "bold" }}> Weekly:</span>{" "}
                                    <span>${parseFloat(space.weekly_rate).toFixed(2)}</span>
                                </p>
                                <p>
                                    <span style={{ fontWeight: "bold" }}> Monthly:</span>{" "}
                                    <span>${parseFloat(space.monthly_rate).toFixed(2)}</span>
                                </p>
                            </div>
                            {space?.active_image && <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom:'5px'
                                }}
                            >
                                <a
                                    onClick={()=>{
                                        setImages({image_url:space?.image_url,image_url_2:space?.image_url_2})
                                        setOpen(true)
                                    }}
                                    style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        color: "#1976d2",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    view Images
                                </a>
                            </div>}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <a
                                    onClick={handleToggleDetails}
                                    style={{
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        color: "#1976d2",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                    }}
                                >
                                    {expanded ? "Hide Details" : "View More Details"}
                                </a>
                                <Button
                                    className="remoteResButton"
                                    style={{
                                        width: "100px"
                                    }}
                                    onClick={() => { bookSpace(space) }}
                                // onClick={handleBookSpace}
                                >
                                    Book Now
                                </Button>
                            </div>
                        </div>
                    </CardContent>
                </Grid>
            </Grid>
            {expanded && (
                <Grid
                    container
                    spacing={1}
                    style={{ margin: "10px", textAlign: "left" }}
                >
                    <Grid item xs={6} sm={3}>
                        <Typography>● {space.sitetype_name}</Typography>
                    </Grid>

                    <Grid item xs={6} sm={3}>
                        {space.power_50a || space.power_30a || space.power_15a
                            ?
                            <Typography>● Electric ({space.power_50a ? '50A' : space.power_30a ? '30A' : '15A'})</Typography>
                            :
                            <Typography>● No Electric</Typography>
                        }
                    </Grid>

                    <Grid item xs={6} sm={3}>
                        {space.water
                            ?
                            <Typography>● Water</Typography>
                            :
                            <Typography>● No Water</Typography>
                        }
                    </Grid>

                    <Grid item xs={6} sm={3}>
                        {space.sewer
                            ?
                            <Typography>● Sewage</Typography>
                            :
                            <Typography>● No Sewage</Typography>
                        }
                    </Grid>

                    {space.selected_eminities.map((x)=>{
                        return(<Grid item xs={6} sm={3}>
                            <Typography>● {x}</Typography>
                    </Grid>)
                        
                    })}
                </Grid>
            )}
        </Card>)
    }

    const SitesAndSpaces = ({ spaceData, bookSpace }) => {
        const [open, setOpen] = useState(false);
        const [images, setImages] = useState({});
        return (
            spaceData && spaceData.length > 0 ? <>
                <h2 className="tsHeading" style={{ textAlign: "left" }}>{spaceData.length} Results Found</h2>
                <Dialog open={open} onClose={()=>setOpen(false)} maxWidth="md" fullWidth>
                    {/* <DialogTitle>View Images</DialogTitle> */}
                    <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {images.image_url ? (
                        <div style={{ marginBottom: "15px", textAlign: "center" }}>
                        <h4>Main Image</h4>
                        <img src={images.image_url} alt="Main" style={{ maxWidth: "100%", maxHeight: "400px", borderRadius: "10px" }} />
                        </div>
                        ) : (
                        <p>No main image available</p>
                        )}
                        {images.image_url_2 ? (
                        <div style={{ textAlign: "center" }}>
                            <h4>Secondary Image</h4>
                            <img src={images.image_url_2} alt="Secondary" style={{ maxWidth: "100%", maxHeight: "400px", borderRadius: "10px" }} />
                        </div>
                        ) : (
                        <p>No secondary image available</p>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={()=>setOpen(false)} style={{ backgroundColor: "#2dcd7a", color: "#000", padding: "8px 20px", borderRadius: "10px" }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        {spaceData.map((space, index) => (
                            <div key={index} style={{ marginBottom: "20px" }}>
                                <SiteSpacecard space={space} bookSpace={bookSpace} setOpen={setOpen} setImages={setImages}/>
                            </div>
                        ))}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        {mapURL ? (
                            <a href={mapURL} target="_blank" rel="noopener noreferrer">
                                <img src={mapURL} width="100%" alt="Map" />
                            </a>
                        ) : (
                            <img
                                src="/path-to-dummy-image.jpg"
                                width="100%"
                                alt="Park map coming soon"
                                style={{ objectFit: 'cover' }}
                            />
                        )}
                    </Grid>
                </Grid>
            </> : ""
        );
    };

    const FacilityInfo = () => {
        return (
            <Box style={{ textAlign: "left" }}>
                <Typography
                    className="tsHeading" variant="h5" style={{ marginBottom: "10px", fontWeight: "600" }}>
                    Facilities
                </Typography>
                <Typography style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                    {facilities}
                </Typography>

                <Divider style={{ marginTop: "20px" }} />

                <Typography
                    className="tsHeading"
                    variant="h5"
                    style={{ marginTop: "20px", marginBottom: "10px", fontWeight: "600" }}
                >
                    Getting here
                </Typography>
                <Typography>{addressLine1}</Typography>
                <Typography>{addressLine2}</Typography>
                <Typography>{addressLine3}</Typography>

                <Divider style={{ marginTop: "20px" }} />

                <Typography
                    className="tsHeading"
                    variant="h5"
                    style={{ marginTop: "20px", marginBottom: "10px", fontWeight: "600" }}
                >
                    Additional Details
                </Typography>
                <Typography style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                    {additionalDetails}
                </Typography>
            </Box>
        );
    };

    const RulesAndCancellation = () => {
        return (
            <Box style={{ textAlign: "left" }}>
                <Typography className="tsHeading" variant="h5" style={{ marginBottom: "10px", fontWeight: "600" }}>
                    Rules & Cancellation Policy
                </Typography>
                <Typography style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                    {rules}
                </Typography>
                <br />
                <Divider />
                <Typography className="tsHeading"
                    variant="h5"
                    style={{ marginTop: "20px", marginBottom: "10px", fontWeight: "600" }}
                >
                    Changes
                </Typography>
                <Typography style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                    {changes}
                </Typography>
            </Box>
        );
    };

    return (
        <Box sx={{ marginTop: "20px" }}>
            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="reservation tabs"
                orientation={isSmallScreen ? "vertical" : "horizontal"}
                sx={{
                    "& .MuiTabs-indicator": {
                        backgroundColor: "#2dcd7a",
                    },
                    display: "flex",
                    flexDirection: isSmallScreen ? "column" : "row",
                }}
            >
                <Tab
                    sx={{
                        "&.Mui-selected": {
                            color: "#2dcd7a",
                        },
                        "&:hover": {
                            color: "#2dcd7a",
                            borderColor: "#2dcd7a",
                        },
                    }}
                    label="Sites/ Spaces"
                />
                <Tab
                    sx={{
                        "&.Mui-selected": {
                            color: "#2dcd7a",
                        },
                        "&:hover": {
                            color: "#2dcd7a",
                            borderColor: "#2dcd7a",
                        },
                    }}
                    label="Facility Information"
                />
                <Tab
                    sx={{
                        "&.Mui-selected": {
                            color: "#2dcd7a",
                        },
                        "&:hover": {
                            color: "#2dcd7a",
                            borderColor: "#2dcd7a",
                        },
                    }}
                    label="Rules & Cancellation"
                />
            </Tabs>

            <TabPanel value={value} index={0}>
                <SitesAndSpaces spaceData={spaceData} bookSpace={bookSpace} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <FacilityInfo />
            </TabPanel>
            <TabPanel value={value} index={2}>
                <RulesAndCancellation />
            </TabPanel>
        </Box>
    );
}

export default ReservationTabs;
